import { Stack, Typography } from "@mui/material"

import { ConfirmModal } from "../../../../../shared/components/dialogs/ConfirmModal"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

type ProductsOutsideGroupAvailabilityDialogProps = Readonly<{
    products: ReadonlyArray<Readonly<{ id: number; name: string; hasNoOverlap: boolean }>>
    isSaving: boolean
    onConfirm: () => void
    onCancel: () => void
}>

export function ProductsOutsideGroupAvailabilityDialog({
    products,
    isSaving,
    onConfirm,
    onCancel,
}: ProductsOutsideGroupAvailabilityDialogProps) {
    return (
        <LocalizedStrict
            id="product-group-edit-products-outside-availability-dialog"
            attrs={{ title: true, message: true, buttonLabelSubmit: true, buttonLabelCancel: true }}
        >
            <ConfirmModal
                open
                title="Narrow the products' availability?"
                message=""
                buttonLabelSubmit="Save and narrow"
                buttonLabelCancel="Cancel"
                buttonColorSubmit="primary"
                buttonSubmitLoading={isSaving}
                // stays open until the group and its products are saved
                autoCloseAfterSubmit={false}
                handleClick={onConfirm}
                onClose={onCancel}
            >
                <Stack gap=".5rem" alignSelf="stretch">
                    {products.map((product) => (
                        <Stack key={product.id} gap=".125rem">
                            <Typography variant="body2">{product.name}</Typography>
                            {product.hasNoOverlap && (
                                <LocalizedStrict id="product-group-edit-products-outside-availability-dialog-no-overlap-description">
                                    <Typography variant="caption" color="warning.main">
                                        No days or hours in common with the group, so it will follow the group's
                                        availability.
                                    </Typography>
                                </LocalizedStrict>
                            )}
                        </Stack>
                    ))}
                </Stack>
            </ConfirmModal>
        </LocalizedStrict>
    )
}
